import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, Input, InputSwitch } from "../../../controls";
import { Model, UseForm } from "../../../hooks";
import { Alert, Form } from "../../../layout";
import * as actions from "../../../api/actions/actions";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { controller, endpoints } from "../../../api/actions/api";
import { RmvEmptyProp, ToFormData } from "../../../hooks/Method";

const AddEditAccount = (props) => {
  const { _post, _put, _authUser, _defHoa, setShowForm, updData, setAccounts } =
    props;
  const { BankAccMdl } = Model();
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    handleInpCheck,
    resetFormControls,
  } = UseForm(BankAccMdl);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    updData &&
      setValues({ ...updData, isDeposit: JSON.parse(updData.isDeposit) });
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updData]);

  const validateForm = () => {
    let temp = {};
    temp.accName = values.accName !== "" ? "" : "Account name is required.";
    temp.routingNum =
      values.routingNum !== "" ? "" : "Routing number is required.";
    temp.accountNum =
      values.accountNum !== "" ? "" : "Account number is required.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res.status === 201 || res.status === 200) {
          if (setAccounts && res.result.id) {
            updData
              ? setAccounts((x) => [
                  ...x.map((j) => (j.id === res.result.id ? res.result : j)),
                ])
              : setAccounts((x) => [res.result, ...x]);
          }
          setShowForm(false);
          setAlert({
            isOpen: true,
            type: "success",
            title: "Success",
            subTitle: `Bank Account ${
              updData ? "Update" : "Added"
            } Successfully.`,
            onClick: () => setAccounts && navigate("/my_account/bank-accounts"),
          });
        } else
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res.msg,
          });
      };
      if (values.id === 0) {
        values.hoaId = _defHoa.id;
        values.userId = _authUser.id;
        _post(
          endpoints.BankAcc + controller.Post,
          ToFormData(RmvEmptyProp(values)),
          null,
          onComplete
        );
      } else if (values.id !== 0) {
        _put(
          endpoints.BankAcc + controller.Put,
          ToFormData(RmvEmptyProp(values)),
          null,
          onComplete
        );
      }
    }
  };

  const handleClose = () => {
    setShowForm(false);
  };

  return (
    <div className="p-15 bg-white">
      <Form onSubmit={handleSubmit} noValidate>
        <Grid container spacing={3}>
          <div className="tx-center p-20 mt-30 mb-10 w-100pr dark-color">
            <h2 className="h fw-5 mb-5">
              {updData ? "Edit" : "Add"} Bank Account
            </h2>
            <div className="pos-relative d-flex j-center">
              <div className="border-bottom w-60" />
            </div>
          </div>
          <Grid item xs={12}>
            <Input
              label="Bank Account Name"
              name="accName"
              value={values.accName}
              error={errors.accName}
              onChange={handleInpChg}
              fullWidth
              inputProps={{ maxLength: 300 }}
            />
          </Grid>
          <Grid item xs={12}>
            <Input
              label="Bank Routing Number"
              name="routingNum"
              value={values.routingNum}
              error={errors.routingNum}
              onChange={handleInpChg}
              type="number"
              onInput={(e) => (e.target.value = e.target.value.slice(0, 30))}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Input
              label="Bank Account Number"
              name="accountNum"
              value={values.accountNum}
              error={errors.accountNum}
              type="number"
              onInput={(e) => (e.target.value = e.target.value.slice(0, 30))}
              onChange={handleInpChg}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputSwitch
              label="Save as a deposit destination for online payments from homeowners."
              fontSize="15px"
              name="isDeposit"
              checked={values.isDeposit}
              onChange={handleInpCheck}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Button variant="text" size="large" onClick={handleClose} fullWidth>
              Cancel
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <Button loading={loading} size="large" type="submit" fullWidth>
              Save
            </Button>
          </Grid>
        </Grid>
      </Form>

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  _authUser: state.storeData.authUser,
  _defHoa: state.storeData.defHoa,
});

const mapActionToProps = {
  _post: actions.post,
  _put: actions.put,
  _getById: actions.getById,
};

export default connect(mapStateToProps, mapActionToProps)(AddEditAccount);
